import { METHODS } from '../constants';
import utils from '../utils';

export interface MFKYCPostData {
  bankAccount1: string;
  bankAccount2: string;
  bankAccount3: string;
  bankAccount4: string;
  modificationRequest?: boolean;
}
export interface FatcaPostData {
  countryOfBirth: string;
  placeOfBirth: string;
  addressType: string;
  countryTaxResidency: string;
  taxIdentificationNumber: string;
  annualIncome: string;
  sourceOfIncome: string;
  Occupation: string;
  pep: string;
}
export interface RiskProfilePostData {
  riskProfile: string;
  custId: string| string[];
}
export interface RiskProfileAnswersPostData {
  answerId1: string;
  answerId2: string;
  answerId3: string;
  answerId4: string;
  answerId5: string;
  answerId6: string;
}
export interface LinkAccountPostData {
  bankAccount1: string;
  bankAccount2: string;
  bankAccount3: string;
  bankAccount4: string;
}

export interface BankAccountLinkOtpData {
  bankAccount1: string;
}
export interface BankAccountLinkOtpVerifyData {
  account: { bankAccount1: string };
  otp: string;
}

const registration = () => ({
  getKycDetails: () => utils.fetch(`${process.env.HOST}/api/registration/details`),
  getMFKycDetails: () => utils.fetch(`${process.env.HOST}/api/registration/customer-demographic`),
  getRiskProfileQuestions: () => utils.fetch(`${process.env.HOST}/api/registration/risk-profile-qa`),
  getFatcaDetails: () => utils.fetch(`${process.env.HOST}/api/registration/fatca-details`),
  getAccountsList: () => utils.fetch(`${process.env.HOST}/api/registration/bank-account`),
  submitMFKycDetails: (data: MFKYCPostData) =>
    utils.fetch(`${process.env.HOST}/api/registration/kyc-registration`, { data: data, method: METHODS.POST }),
  submitFatcaDetails: (data: FatcaPostData) =>
    utils.fetch(`${process.env.HOST}/api/registration/submit-fatca-details`, { data: data, method: METHODS.POST }),
  submitRiskProfile: (data: RiskProfilePostData) =>
    utils.fetch(`${process.env.HOST}/api/registration/submit-risk-profile-direct`, {
      data: data,
      method: METHODS.POST,
    }),
  submitRiskProfileQuestions: (data: RiskProfileAnswersPostData) =>
    utils.fetch(`${process.env.HOST}/api/registration/submit-risk-profile`, { data: data, method: METHODS.POST }),
  linkBankAccount: (data: LinkAccountPostData) =>
    utils.fetch(`${process.env.HOST}/api/registration/account-link`, { data: data, method: METHODS.POST }),
  autoLinkBankAccount: () =>
    utils.fetch(`${process.env.HOST}/api/registration/auto-bank-linking`, { method: METHODS.POST }),
  bankAccountLinkOtp: (data: BankAccountLinkOtpData) =>
    utils.fetch(`${process.env.HOST}/api/registration/account-link/otp`, { method: METHODS.POST, data: data }),
  bankAccountLinkOtpVerify: (data: BankAccountLinkOtpVerifyData) =>
    utils.fetch(`${process.env.HOST}/api/registration/account-link/otp/verify`, { method: METHODS.POST, data: data }),
  getEmailBotfDetails: () => utils.fetch(`${process.env.HOST}/api/registration/SSO-Botf-Details`),    
  submitFatherSpouseName: (fatherSpouseName) => utils.fetch(`${process.env.HOST}/api/registration/submit-father-name?fatherName=${fatherSpouseName}`),
});

export default registration;
